module.exports = __webpack_public_path__ + "img/jiangbei01.png";